export const lang = {
  companyName: 'NESC',
  /* 首页 */
  home: 'Home',

  /* 关于我们 */
  about: 'About Us',
  corporateCulture: 'Corporate Culture',
  companyProfile: 'Company Profile',
  developmentHistory: 'Development History',
  productionOffice: 'Production Office',
  cellProductionLine: 'Cell Production Line',

  /* 产品系列 */
  productGroup: 'Products',
  highRateCell: 'High Rate BatteryCell',
  batteryModule: 'Battery Module',

  /* 解决方案 */
  solutions: 'Solutions',
  heavyTransport: 'Heavy Transport',
  logisticsFreight: 'Logistics Freight',
  cityDelivery: 'City Delivery',
  lightPassengerVehicle: 'Light Passenger Vehicle',
  highSpeedMotorcycle: 'HighSpeed Electric Motorcycle',
  electricalTools: 'Electrical Tools',
  drone: 'Drone',

  /* 创新技术 */
  technology: 'R&D',
  materialTechnology: 'Material Technology',
  structuralTechnology: 'Structural Technology',
  cloudPlatform: 'Safety Technology',

  /* 新闻 */
  news: 'News',

  /* 联系我们 */
  contactUs: 'Contact Us',
  talentRecruitment: 'Talent Recruitment',
  channelCooperation: 'Channel Cooperation',
  bidAnnouncement: 'Bid Announcement',

  privacyPolicyInformationSecurity: 'Privacy and Information Security',
  legalNote: 'Legal',

  homeText: "Build a new scene of super fast charging",
  homeText1: "Charging like refueling",


  newsTitle: 'News',
  checkMore: 'Check More',

  vision: 'Vision',
  visionContent: 'Drive the world\'s energy transformation with ultra-electric power',
  mission: 'Mission',
  missionContent: "Keep Innovation for unlimited energy of users",
  coreValue: 'Core Value',
  coreValueContent: 'Innovation &nbsp; Excellence &nbsp; Integrity &nbsp; Win',
  companyProfileContent: 'ChaoDian Group was established in 2015 and is a nationally recognized high-tech enterprise specializing in the research and development and manufacturing of power-type batteries. The company\'s products integrate six core advantages: ultra-fast charging, super safety, ultra-high energy density, ultra-wide temperature range, ultra-low internal resistance, and ultra-long cycle life. They represent an all-around "hexagonal warrior"—the super battery, which is indeed Super Electric!\n' +
    '\n' +
    'The company\'s products are widely used in high-speed electric motorcycles, low-altitude economy sectors, robotics, digital electronics, electric tools, and engineering power applications, providing global customers with complete minute-level ultra-fast charging solutions. As the first in the industry to achieve large-scale operation of minute-level ultra-fast charging system solutions, the company’s core commercial operation capabilities remain industry-leading.\n' +
    '\n' +
    'Since the official market launch of its products on June 18, 2015, the group has served over 300,000 vehicles equipped with minute-level ultra-fast charging systems, deployed more than 30,000 minute-level ultra-fast charging stations, and achieved over 100 million safe ultra-fast charging operations. This has established an outstanding operational record of ten years with zero safety incidents and zero insurance claims.',

  historyList2015: 'Jiangsu ChaoDian Technology Development Co., Ltd was established in Wuxi',
  historyList2016: 'Minute-level Super Fast Charging Chip Product Launched',
  historyList2017: 'Nationwide Promotion of Super Fast Charging Industry Application Demonstrations',
  historyList2018: 'The nation’s first super fast-charging battery full lifecycle cloud platform has been put into operation',
  historyList2020: 'The first phase of the Shandong production base is under construction',
  historyList2022: 'Obtain strategic investment for production line planning in five major production areas',
  historyList2024: 'The first phase of the production line at the production base in Anhui headquarters has been put into operation',
  historyList2025: 'The first phase of the production base at the headquarters in Anhui has been put into operation, and the second phase has commenced. Meanwhile, the second phase project of the production base in Shandong has been initiated',
  historyList2029: 'IPO',

  previous:'Prev',
  next: 'Next',

  loopLife: 'Cycle Life',
  energyDensity: 'Energy Density',
  workTemp: 'Working Temp',
  standardVol: 'Standard Vol',
  chargeRate: 'Charge Rate',
  dischargeRate: 'Discharge Rate',

  platformDevelop: 'Platform Develop',
  moduleFreeSet: 'Modules Free Configure',
  highRate: 'Ultra High Magnification',
  highHengLiu: 'Ultra High Constant Current Rate',
  highLoopLife: 'Long Cycle Life',
  highTempRange: 'Wide Charging Temperature Range',
  highPower: 'High Energy Density',

  heavyCarContent: 'ChaoDian power battery provides surging power for heavy-duty transportation vehicles, meet the needs of various complex working conditions such as construction sites, mines, ports, and road engineering construction, greatly save charging time, reduce unit use costs, improve operational efficiency, and reduce fuel carbon. Emissions provides practical solutions for efficient application scenarios.',
  huoCheContent: 'ChaoDian power battery products have the characteristics of high safety, long life, strong environmental adaptation, etc., covering pure electric vans, electric cleaning vehicles, electric cleaning vehicles, electric garbage collection and transportation vehicles and other freight models, with zero pollution and zero emissions.',
  sanLunContent: 'ChaoDian provides green, intelligent and safe super fast charging system application solutions for electric two-wheelers and tricycles.',
  chenYongContent: 'ChaoDian continues to innovate by providing single cells with super fast charging, ultra-high energy ratio, ultra-high power ratio, and ultra-long life for passenger cars, as well as battery pack design and energy system storage efficiency, etc. Come on!", truly realizing worry-free battery life.',
  elecMoContent: 'Through the revolutionary super fast charging technology, flexible cell configuration scheme and intelligent BMS super fast charging management strategy, ChaoDian enables high-speed electric motorcycle customers to enjoy the same acceleration, battery life and durability as world-class brands while enjoying global Leading super fast charging and super safe.',
  elecContent: 'According to the needs of power tools in metal cutting, grinding, assembly, railway and garden application scenarios, ChaoDian provides battery product solutions with fast charging, wide temperature resistance, long life and strong power.',
  wuRenJiContent: 'Through the revolutionary super fast charging and intelligent control technology, ChaoDian brings an effective spraying load of 40 kg and a spreading load of 50 kg, creating a new benchmark for efficient, convenient and intelligent agriculture.',

  channelInvestment: 'Channel Investment',
  businessCooperation: 'Business Cooperation',
  contactInformation: "Contact Info",
  ext: "ext.",
  contact: 'contact',
  yuChao: 'Mr.Yu',
  caoYanJiang: 'Mr.Cao',

  zhaoPinTitle1: 'Working at ChaoDian makes a big difference',
  zhaoPinTitle2: 'Make exciting products together',
  zhaoPinTitle3:'Do things with smart people',

  zhaoPinContent1: 'At ChaoDian, the working atmosphere allows everyone to actively innovate and work hard for good things. There is no hierarchy of big companies here, and everyone can come up with their own ideas and ideas at any time.',
  zhaoPinContent2: 'Let everyone enjoy the fun of technology. ChaoDian has launched the world\'s first mobile power supply that can be fully charged in 800 seconds - ChaoDianbao, establishing the leading position of graphene application in the field of mobile power!',
  zhaoPinContent3:'ChaoDian has a first-class Internet talent gene. In May 2015, it invested and established Jiangsu ChaoDian New Energy to provide energy system integration solutions and technical support services for customers in the fields of industry, military and consumer goods.',

  joinUs: 'Join Us',
  jobTitle: 'Job Title',
  jobCategories: 'Job Categories',
  numberOfRecruits: 'Number Of Recruits',
  workPlace: 'Work Place',
  releaseDate: 'Release Date',
  more: 'More',
  operate: 'Operate',
  check: 'Details',

  recruitment: 'Recruitment',
  monthlySalary: 'Monthly Salary',
  descriptionOfJob: 'Job Description',
  workContent: 'Work Content',
  companyBenefits: 'Company Benefits',
  jobRequirements: 'Job Requirements',

  address: "Address",
  phone: "Tel",
  email: "Email",
  choseLanguage: 'Language'
}
